<template>
    <div class="helpSupport">
        <img :src="bannerPath"
             @click="jump()"
             v-if="bannerPath!=''" />
        <el-row type="flex"
                class="row-bg field"
                justify="center">
            <el-col :span="9"
                    class="position">
                <el-input v-model="problem"
                          placeholder="请输入要查询的内容"></el-input>
                <i @click="questionquery"
                   class="el-icon-search"></i>
            </el-col>
        </el-row>
        <!-- <div class="way">
            <el-row type="flex"
                    class="row-bg"
                    justify="center">
                <el-col :span="20">
                    <breadcrumb></breadcrumb>
                </el-col>
            </el-row>
        </div> -->
        <el-row type="flex"
                class="row-bg bottombor"
                justify="center">
            <el-col :span="20"
                    class="main">
                <div class="btn"
                     v-for="(item,index) in brotherMenu"
                     :key="index"
                     @click="assign(item)"
                     :class="{active: activeIndex === item.id}">
                    <p class="line">{{item.name}}</p>
                </div>
            </el-col>
        </el-row>
        <keep-alive>
            <component :is="currentpage"></component>
        </keep-alive>
    </div>
</template>

<script>
import Bus from "@/utils/bus";
import { queryproductbanner } from "@/api/productInfo";
import { mapGetters } from "vuex";
import download from "@/views/helpcenter/download";
import mailing from "@/views/helpcenter/mailing";
import management from "@/views/helpcenter/management";
import queryNode from "@/views/helpcenter/queryNode";
import trajectory from "@/views/helpcenter/trajectory";
import complaint from "@/views/helpcenter/complaint";
import consultation from "@/views/helpcenter/consultation";
import proposal from "@/views/helpcenter/proposal";
import woscomplaint from "@/views/helpcenter/woscomplaint";
// import questionquery from "@/views/helpcenter/questionquery";
import breadcrumb from "@/components/breadcrumb";
export default {
    components: {
        download,
        mailing,
        management,
        queryNode,
        trajectory,
        breadcrumb,
        complaint,
        consultation,
        proposal,
        woscomplaint
        // questionquery
    },
    watch: {
        //监听路由变化
        $route(to, from) {
            this.currentpage = this.$route.params.id;
            // this.search();
        }
    },
    computed: {
        ...mapGetters([
            "activeIndex",
            "parentList",
            "bannerPath",
            "brotherMenu"
        ])
    },

    created() {
        // this.search();
        this.currentpage = this.$route.params.id;
    },
    mounted() {
        if (sessionStorage.getItem("activeIndex")) {
            this.$store.dispatch(
                "BannerPath",
                sessionStorage.getItem("activeIndex")
            );
            //this.getInitBanner(sessionStorage.getItem("activeIndex")); "/proddetails/transportation"
        }
        //this.queryBannerInit(this.activeIndex);
    },

    data() {
        return {
            problem: "",
            currentpage: "trajectory",
            imaUrl: "",
            list: [
                { name: "trajectory", title: "常见问题" },
                { name: "mailing", title: "货物追踪" },
                { name: "queryNode", title: "增值服务" },
                { name: "management", title: "问题咨询" },
                { name: "download", title: "下载" }
            ]
        };
    },

    methods: {
        queryBannerInit() {},
        jump() {
            queryproductbanner(this.activeIndex).then(res => {
                if (res.status === 2000) {
                    if (res.data.demoFlag) {
                        this.$store.dispatch("UpdateActive", res.data);
                    }
                }
            });
        },
        assign(item) {
            this.$router.push({
                path: item.demoFlag,
                query: {
                    id: item.id
                }
            });
            this.$store.dispatch("BannerPath", item.id);
            // this.$store.dispatch("UpdateActive", item);
            this.$store.dispatch("ContentDesc", item.id);
        },

        questionquery() {
            // setTimeout(() => {
            //     Bus.$emit("toquestionquery", this.problem);
            // }, 50);
            this.$router.push({
                path: "/questionquery",
                query: {
                    id: "CD97B339-06E7-1354-E2CF-2570A964B7D4",
                    search: this.problem
                }
            });
        }
    }
};
</script>

<style scoped lang="scss">
.helpSupport {
    .banner {
        width: 100%;
        height: 100;
    }
    img {
        width: 100%;
        // max-height: 400px;
    }
    .field {
        position: relative;
        .position {
            position: absolute;
            bottom: 30px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 9;
            .el-input {
                width: 100%;
                /deep/ .el-input__inner {
                    border-radius: 20px;
                    background-color: rgba(255, 255, 255, 0.9);
                    color: #000;
                }
            }
            .el-icon-search {
                cursor: pointer;
                font-size: 26px;
                color: #fabe00;
                position: absolute;
                top: 7px;
                right: 16px;
            }
        }
    }
    .way {
        height: 50px;
        margin-top: -3px;
        background-color: #221814;
        .el-breadcrumb {
            line-height: 50px;
        }
    }
    .service {
        position: relative;
        top: -81px;
        .bgcolor {
            background-color: #fff;
            p {
                font-size: 19px;
                font-weight: 600;
                line-height: 71px;
                text-align: center;
            }
            .el-col {
                height: 159px;
            }
        }
    }
    .icon {
        margin-top: -73px;
        .ico {
            background-color: #fff;
            height: 159px;
            box-shadow: 0 1px 10px 0 rgba(241, 194, 43, 0.6);
            .onnerwidth {
                width: 20%;
                float: left;
                img {
                    cursor: pointer;
                    margin-top: 43px;
                    position: relative;
                    left: 50%;
                    transform: translateX(-50%);
                }
                p {
                    font-size: 15px;
                    text-align: center;
                    margin-top: 14px;
                }
            }
            .onnerwidth:hover {
                transition: transform 0.7s;
                transform: translateY(-10px);
            }
        }
    }
    .bottombor {
        border-bottom: 1px solid #ddd;
        .main {
            background-color: #fff;
            display: flex;
            .btn {
                flex: 1;
                cursor: pointer;
                height: 54px;
                margin: 0 auto;
                display: inline-block;
                text-align: center;
                font-size: 20px;
                line-height: 54px;
            }
        }
    }

    .active {
        border-bottom: 2px solid #fabe00;
    }
}
</style>
